import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonComponent } from '../../ui/button/button.component';

@Component({
  selector: 'app-two-factor-prompt',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonComponent],
  templateUrl: './two-factor-prompt.component.html'
})
export class TwoFactorPromptComponent {
  /**
   * When 2FA is enabled, parent component can show this prompt
   * and receive the submitted token via (codeSubmit).
   */
  @Input() loading = false;
  @Input() errorMessage = '';
  @Input() emailHint?: string;
  @Output() codeSubmit = new EventEmitter<string>();
  @Output() back = new EventEmitter<void>();

  code = '';

  submit(): void {
    const trimmed = this.code.trim();
    if (!trimmed) {
      this.errorMessage = 'Enter the 6-digit code from your authenticator app.';
      return;
    }
    this.codeSubmit.emit(trimmed);
  }

  goBack(): void {
    this.back.emit();
  }
}
